var _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyllabusPlusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 36,
    viewBox: "0 0 168 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Syllabus+") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 9,
    fill: "#3b8eff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 26,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#ffffff",
    textAnchor: "middle",
    letterSpacing: -0.5
  }, "s+")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 25,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 21,
    fontWeight: 300,
    fill: "#ffffff",
    letterSpacing: -0.4
  }, "syllabus", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#3b8eff"
  }, "+"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabusPlusLogo);
export default __webpack_public_path__ + "static/media/syllabus_plus_logo.4b1f99f4575699f9d5f62458d6a1ab3e.svg";
export { ForwardRef as ReactComponent };